import { FRONTIFY_URL } from './media';

// Shared app download button images
const APP_DOWNLOAD_IMAGES = {
  APP_STORE: `${FRONTIFY_URL}tnEevkk6pjA2sLZ7TanK.svg`,
  GOOGLE_PLAY: `${FRONTIFY_URL}1L33ZRHhMPBMtRsZWAkg.svg`,
} as const;

export { APP_DOWNLOAD_IMAGES };
